import { useCallback } from 'react';

import { Header } from '@rbilabs/universal-components';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { useIntl } from 'react-intl';
import { FlatList } from 'react-native';

import { CardModal } from 'components/card-modal';
import { useModalAnalyticsAppearanceEvent } from 'hooks/use-modal-analytics-appearance-event';
import { useLoyaltyContext } from 'state/loyalty';
import { LoyaltyOfferWithInlineAlertMessage } from 'state/loyalty/hooks/types';
import { useLoyaltyOfferGroupsById } from 'state/loyalty/hooks/use-loyalty-offer-groups-by-id';
import { routes } from 'utils/routing';

import { LoadingAnimation } from '../loyalty-claim-points/loyalty-claim-points.styled';

import { renderOfferItem } from './loyalty-list-item';

export const OffersGroupsDetails: React.FC = () => {
  const { offerGroupId } = useLocalSearchParams<{ offerGroupId?: string }>();

  const { setAddOffersCallbackUrl } = useLoyaltyContext();
  const { offers, groupName, loading: offersLoading } = useLoyaltyOfferGroupsById(offerGroupId);
  const router = useRouter();
  const { formatMessage } = useIntl();

  const handleOfferPress = useCallback(
    (incentive: LoyaltyOfferWithInlineAlertMessage) => {
      const incentiveId = incentive.loyaltyEngineId;
      const qs = offerGroupId ? `?groupId=${offerGroupId}` : '';
      router.navigate(`${routes.loyaltyOfferList}/${incentiveId}${qs}`);
    },
    [router, offerGroupId]
  );

  const renderItem = ({ item }: { item: LoyaltyOfferWithInlineAlertMessage }) => {
    return renderOfferItem({
      item,
      handlePress: () => {
        if (item?.inlineAlertMessage) {
          return;
        }
        setAddOffersCallbackUrl(`${routes.loyaltyOfferGroup}/${offerGroupId}`);
        handleOfferPress(item);
      },
      skipAnimation: true,
    });
  };
  useModalAnalyticsAppearanceEvent('Offers Group Details');

  return (
    <CardModal
      isLoading={!groupName}
      headerText={groupName}
      testID="offers-group-items-modal"
      standardPadding
    >
      <Header variant="headerThree" alignSelf="center" marginBottom="$8" marginTop={'$4'}>
        {formatMessage({ id: 'selectOffer' })}
      </Header>
      {offersLoading ? (
        <LoadingAnimation />
      ) : (
        <FlatList
          data={offers}
          keyExtractor={(item, index) => item._id || `${index}`}
          renderItem={renderItem}
        />
      )}
    </CardModal>
  );
};
